import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        fsAnswer: '<',
        index: '=',
        progress: '=',
        ok: '&',
        cancel: '&'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.cancel()"></button>
        <h2>{{ 'validations.Validation' | translate }}</h2>
    </div>
    <form>
        <div class="modal-body">
            <div class="form">
                <div class="row row-wide">
                    <span class="label type02">{{ 'forms.Question' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.fsAnswer.question.nameWithoutHtml }}</span></div>
                </div>
                <div class="row row-wide">
                    <span class="label type02">{{ 'question.Answer' | translate }}</span>
                    <div class="items">
                        <span class="text">
                            {{ vm.fsAnswer.question.answer ? vm.fsAnswer.answer.text : vm.fsAnswer.answerText }}
                        </span>
                    </div>
                </div>
                <div class="row" ng-if="vm.fsAnswer.question.isAssessmentNeeded">
                    <label class="label type02">{{ 'questions.Points' | translate }}</label>
                    <div class="items">
                        <input ng-if="!vm.fsAnswer.question.points" ng-model="vm.fsAnswerClone.points" type="text" class="form-control">
                        <input ng-if="vm.fsAnswer.question.points" ng-model="vm.fsAnswerClone.points" type="number" step="1" class="form-control small02">
                        <span ng-if="vm.fsAnswer.question.points" class="text">{{ 'validations.Maximum points allowed' | translate }}: {{ vm.fsAnswer.question.points }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li ng-if="vm.fsAnswer.question.isAssessmentNeeded" class="primary">
                    <button ng-click="vm.save(false)" class="btn main">{{ 'validations.Save assessment' | translate }}</button>
                </li>
                <li ng-if="vm.isNext() && vm.fsAnswer.points===null && vm.fsAnswer.question.isAssessmentNeeded" class="primary">
                    <button ng-click="vm.save(true)" class="btn bordered02">{{ 'validations.Save and assess next' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    </form>
    `
})
export default class {
    constructor (FormSubmissionAnswerResource, lodash, TrainingProgressResource, $rootScope, toastr,
        ErrorHandlerFactory) {
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.lodash = lodash;
        this.TrainingProgressResource = TrainingProgressResource;
        this.$rootScope = $rootScope;
        this.toastr = toastr;
        this.ErrorHandlerFactory = ErrorHandlerFactory;

        this.processedIds = [];
    }

    $onInit () {
        this.fsAnswerClone = this.lodash.clone(this.fsAnswer);
        this.isNext();
    }

    save (takeNext = false) {
        // need to store this state in case of errors to rollback
        this.initialfsAnswer = this.fsAnswer;
        this.fsAnswer = this.fsAnswerClone;
        this.fsAnswer.isPointsRequired = true;
        this.fsAnswer.isAssessmentAnswer = this.fsAnswer.question.isAssessmentNeeded;
        this.FormSubmissionAnswerResource.update({ id: this.fsAnswer.id }, this.fsAnswer).$promise
        .then(() => {
            this.$rootScope.$broadcast('reload:progress');
            if (takeNext === false) {
                this.ok();
            }
            else {
                this.processedIds.push(this.fsAnswer.id);
                this.fsAnswer = this.getNext();
                this.fsAnswerClone = this.lodash.clone(this.fsAnswer);
            }
        }).catch((response) => {
            this.fsAnswer = this.initialfsAnswer;
            this.handleErrors(response);
        });
    }

    handleErrors (response) {
        const errors = this.ErrorHandlerFactory.parseFormErrors(response);
        const uniqueErrors = [];
        this.lodash.forEach(errors, (error) => {
            if (uniqueErrors.indexOf(error) === -1) {
                this.toastr.error(error);
                uniqueErrors.push(error); // filter out duplicate errors
            }
        });
    }

    isNext () {
        let needsValidationCount = 0;
        this.lodash.forEach(this.progress.formSubmission.formSubmissionAnswers, (fsAnswer) => {
            if (fsAnswer.question.isAssessmentNeeded === true && !fsAnswer.points && !this.processedIds.includes(fsAnswer.id)) {
                needsValidationCount++;
            }
        });
        return needsValidationCount > 1;
    }

    getNext () {
        const answers = this.progress.formSubmission.formSubmissionAnswers.filter(fsAnswer => {
            return fsAnswer.question.isAssessmentNeeded === true && !fsAnswer.points && !this.processedIds.includes(fsAnswer.id);
        });
        return answers[0];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/validations/detail/assess/index.js